import React from 'react';

export default function LanguageIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.002 22C17.5248 22 22.002 17.5228 22.002 12C22.002 6.47715 17.5248 2 12.002 2C6.4791 2 2.00195 6.47715 2.00195 12C2.00195 17.5228 6.4791 22 12.002 22Z"
        stroke="#60EC2F"
        stroke-width="1.33282"
        stroke-linecap="square"
      />
      <path
        d="M12 22C14.6667 19.5758 16 16.2424 16 12C16 7.75758 14.6667 4.42424 12 2C9.33333 4.42424 8 7.75758 8 12C8 16.2424 9.33333 19.5758 12 22Z"
        stroke="#60EC2F"
        stroke-width="1.33282"
        stroke-linecap="round"
      />
      <path
        d="M2.50195 8.99902H21.502M2.50195 14.999H21.502"
        stroke="#60EC2F"
        stroke-width="1.33282"
        stroke-linecap="round"
      />
    </svg>
  );
}
